var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmarkO(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3h10a1 1 0 011 1v16l-6-3.778L6 20V4a1 1 0 011-1z",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E %3Cg fill='none' fill-rule='evenodd' stroke-width='2'%3E %3Cpath d='M7 3h10c.552 0 1 .448 1 1v16h0l-6-3.778L6 20V4c0-.552.448-1 1-1z'/%3E %3C/g%3E %3C/svg%3E";
export { SvgBookmarkO as ReactComponent };